module.exports = __webpack_public_path__ + "fonts/righthand-extbolddash-personal.5a1a8856.ttf";